
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/providers/available",
      function () {
        return require("private-next-pages/providers/available/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/providers/available"])
      });
    }
  